module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/node_modules/readable-stream/lib/internal/streams/stream-browser.js
// module id = 869
// module chunks = 7